import drop from './drop'

export default function tail (arr) {
  return drop(1, arr)
}
